<h2 mat-dialog-title cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragHandle>{{ "trips.activity.museum-title" | translate }}</h2>
<ng-container *ngIf="form">
  <mat-dialog-content [formGroup]="form" class="dialog-content">
    <div class="grid-container">
      <!-- Name (Read-Only) -->
      <mat-form-field
        appearance="outline"
        class="mat-form-field-readonly span-2-cols"
      >
        <mat-label class="label-text-readonly">{{
          "museums.museum-name" | translate
        }}</mat-label>
        <input matInput formControlName="name" readonly />
      </mat-form-field>

      <!-- Description -->
      <mat-form-field appearance="outline" class="span-3-cols">
        <mat-label>{{ "description" | translate }}</mat-label>
        <textarea
          appCombinedReadonly
          [forbiddenRoles]="['TRAVEL_DESIGNER']"
          matInput
          formControlName="description"
          maxlength="300"
          rows="3"
        ></textarea>
        <mat-hint
          >{{ form.get("description")?.value?.length || 0 }}/300</mat-hint
        >
      </mat-form-field>

      <!-- Disclaimer -->
      <mat-form-field appearance="outline" class="span-3-cols">
        <mat-label>{{ "disclaimer" | translate }}</mat-label>
        <textarea
          appCombinedReadonly
          [forbiddenRoles]="['TRAVEL_DESIGNER']"
          matInput
          formControlName="disclaimer"
          maxlength="300"
          rows="3"
        ></textarea>
        <mat-hint
          >{{ form.get("disclaimer")?.value?.length || 0 }}/300</mat-hint
        >
      </mat-form-field>

      <!-- Notes -->
      <mat-form-field appearance="outline" class="span-3-cols">
        <mat-label>{{ "notes" | translate }}</mat-label>
        <textarea
          matInput
          formControlName="notes"
          maxlength="500"
          rows="3"
        ></textarea>
        <mat-hint>{{ form.get("notes")?.value?.length || 0 }}/500</mat-hint>
      </mat-form-field>

      <!-- Address -->
      <input-link
        formFieldClass="span-3-cols"
        formControlName="address"
        [label]="'museums.address'"
      ></input-link>

      <!-- Full Price -->
      <input-monetary-amount
        appCombinedReadonly
        #totalPriceReadonly="appCombinedReadonly"
        [forbiddenRoles]="['ACCOUNTANT']"
        [forbiddenStates]="['PAID_BY_CUSTOMER']"
        [combineMode]="'AND'"
        formFieldClass="span-3-cols"
        formControlName="fullPrice"
        label="full-price"
      ></input-monetary-amount>

      <!-- Reduced Price -->
      <input-monetary-amount
        appCombinedReadonly
        #totalPriceReadonly="appCombinedReadonly"
        [forbiddenRoles]="['ACCOUNTANT']"
        [forbiddenStates]="['PAID_BY_CUSTOMER']"
        [combineMode]="'AND'"
        formFieldClass="span-3-cols"
        formControlName="reducedPrice"
        label="reduced-price"
      ></input-monetary-amount>

      <!-- Start Time -->
      <input-time
        formFieldClass="span-3-cols"
        name="time"
        formControlName="startTime"
        [required]="true"
        label="start-time"
      ></input-time>

      <!-- End Time -->
      <input-time
        formFieldClass="span-3-cols"
        name="time"
        formControlName="endTime"
        [required]="true"
        label="end-time"
      ></input-time>
    </div>
    <!-- Tickets List -->
    <input-ticket-list [(tickets)]="tickets"></input-ticket-list>
  </mat-dialog-content>

  <mat-dialog-actions align="end" class="dialog-content">
    <button mat-button (click)="cancel()">{{ "cancel" | translate }}</button>
    <button
      mat-raised-button
      color="primary"
      (click)="confirm()"
      [disabled]="!form.valid || tickets.length === 0"
    >
      {{ "confirmation" | translate }}
    </button>
  </mat-dialog-actions>
</ng-container>
